<template>
    <div class="col-12 newsletter-mailing-settings">
        <div class="row">
            <div class="col-12 col-md-10 col-lg-9 p-0">
                <form method="POST" class="newsletter-mailing-settings__content-wrapper mb-5">
                    <div class="newsletter-mailing-settings__header">
                        <h2 class="newsletter-mailing-settings__title">{{ $t("unsubPage.changeEmailSettings") }}</h2>
                    </div>
                    <div class="newsletter-mailing-settings__content">
                        <div class="newsletter-mailing-settings__image-wrapper">
                            <img
                                :src="sadnessLevelOfTheDog" alt="#"
                                class="newsletter-mailing-settings__image"
                            />
                        </div>
                        <div>
                            <div v-if="isCustomer" class="py-4">
                                <label class="newsletter-mailing-settings__input-label">
                                    {{ $t("unsubPage.emailKnown") }}
                                    <span v-text="email"></span>
                                </label>
                            </div>
                            <div v-else class="py-4 col-8 ml-4 form-group form-group__padding">
                                <label for="email">{{ $t("unsubPage.emailadres")}}</label>
                                <p v-show="checkInput('email')" class="text-danger text-xs">
                                    {{ $t('myAccount.errorEmail') }}
                                </p>
                                <div>
                                    <input type="email" v-model="email" id="email" name="email" class="form-control" :class="{'input--error': checkInput('email') }" required>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="newsletter-mailing-settings__input-wrapper">
                                <div class="newsletter-mailing-settings__checkbox-input">
                                    <input
                                        type="radio"
                                        v-model="selectedUnsubscribeOption"
                                        :value="0"
                                        name="selectedUnsubscribeOption0"
                                        id="selectedUnsubscribeOption0"
                                    >
                                </div>
                                <label for="selectedUnsubscribeOption0" class="newsletter-mailing-settings__input-label">
                                    {{ $t("unsubPage.iWant")}}
                                    <span class="newsletter-mailing-settings__input-label--green">
                                        {{ $t("unsubPage.keepProfiting")}}
                                    </span>
                                    {{ $t("unsubPage.ofTheBenefitMail") }}
                                </label>
                            </div>
                            <div class="newsletter-mailing-settings__input-wrapper">
                                <div class="newsletter-mailing-settings__checkbox-input">
                                    <input
                                        type="radio"
                                        v-model="selectedUnsubscribeOption"
                                        :value="1"
                                        name="selectedUnsubscribeOption1"
                                        id="selectedUnsubscribeOption1"
                                    >
                                </div>
                                <label for="selectedUnsubscribeOption1" class="newsletter-mailing-settings__input-label">
                                    {{ $t("unsubPage.sendMe") }}
                                    <span class="newsletter-mailing-settings__input-label--green"> {{ $t("unsubPage.onesEvery2Weeks") }}</span>
                                    {{ $t("unsubPage.exclusiveOffersAndTheBestDiscounts") }}
                                </label>
                            </div>
                            <div class="newsletter-mailing-settings__input-wrapper">
                                <div class="newsletter-mailing-settings__checkbox-input">
                                    <input
                                        type="radio"
                                        v-model="selectedUnsubscribeOption"
                                        :value="2"
                                        name="selectedUnsubscribeOption2"
                                        id="selectedUnsubscribeOption2"
                                    >
                                </div>
                                <label for="selectedUnsubscribeOption2" class="newsletter-mailing-settings__input-label">
                                    <span class="newsletter-mailing-settings__input-label--green">{{ $t("unsubPage.onetimeAMonth")}}</span>
                                    {{ $t("unsubPage.wellEnoughButDontMiss") }}
                                </label>
                            </div>
                            <hr class="newsletter-mailing-settings__mobile-divider"/>
                            <div class="newsletter-mailing-settings__input-wrapper">
                                <div class="newsletter-mailing-settings__checkbox-input">
                                    <input
                                        type="radio"
                                        v-model="selectedUnsubscribeOption"
                                        :value="3"
                                        name="selectedUnsubscribeOption3"
                                        id="selectedUnsubscribeOption3"
                                    >
                                </div>
                                <label for="selectedUnsubscribeOption3" class="newsletter-mailing-settings__input-label">
                                    {{ $t("unsubPage.noBenefit") }}
                                    <span class="newsletter-mailing-settings__input-label--green">{{ $t("unsubPage.writeMeOut") }}</span>
                                </label>
                            </div>
                            <div v-if="selectedUnsubscribeOption === 3" class="mt-3">
                                <div class="newsletter-mailing-settings__radio-button-wrapper">
                                    <div class="newsletter-mailing-settings__input-wrapper">
                                        <input
                                            type="checkbox"
                                            class="newsletter-mailing-settings__radio-button-input"
                                            name="selectedOptOutOptions"
                                            id="discountMail"
                                            :value="true"
                                            v-model="selectedOptOutOptions.discountMail"
                                        >
                                        <label for="discountMail" class="newsletter-mailing-settings__input-label">
                                            {{ $t("unsubPage.benefitMail") }}
                                        </label>
                                    </div>
                                    <div class="newsletter-mailing-settings__input-wrapper">
                                        <input
                                            type="checkbox"
                                            class="newsletter-mailing-settings__radio-button-input"
                                            name="selectedOptOutOptions"
                                            id="birthdayMail"
                                            :value="true"
                                            v-model="selectedOptOutOptions.birthdayMail"

                                        >
                                        <label for="birthdayMail" class="newsletter-mailing-settings__input-label">
                                            {{ $t("unsubPage.birthdayMail")}}
                                        </label>
                                    </div>
                                    <div class="newsletter-mailing-settings__input-wrapper">
                                        <input
                                            type="checkbox"
                                            class="newsletter-mailing-settings__radio-button-input"
                                            name="selectedOptOutOptions"
                                            id="tipsAndAdviseMail"
                                            :value="true"
                                            v-model="selectedOptOutOptions.tipsAndAdviseMail"
                                        >
                                        <label for="tipsAndAdviseMail" class="newsletter-mailing-settings__input-label">
                                            {{ $t("unsubPage.tipsAndAdvice") }}
                                        </label>
                                    </div>
                                    <div class="newsletter-mailing-settings__input-wrapper">
                                        <input
                                            type="checkbox"
                                            class="newsletter-mailing-settings__radio-button-input"
                                            name="selectedOptOutOptions"
                                            id="personalDiscountMail"
                                            :value="true"
                                            v-model="selectedOptOutOptions.personalDiscountMail"
                                        >

                                        <label for="personalDiscountMail" class="newsletter-mailing-settings__input-label">
                                            {{ $t("unsubPage.personalDiscount") }}
                                        </label>
                                    </div>
                                    <div class="newsletter-mailing-settings__input-wrapper">
                                        <input
                                            type="checkbox"
                                            class="newsletter-mailing-settings__radio-button-input"
                                            name="selectedOptOutOptions"
                                            id="reviewMail"
                                            :value="true"
                                            v-model="selectedOptOutOptions.reviewMail"
                                        >

                                        <label for="reviewMail" class="newsletter-mailing-settings__input-label">
                                            {{ $t("unsubPage.productReviewAndReviews")}}
                                        </label>
                                    </div>
                                    <p class="newsletter-mailing-settings__option-information">
                                        {{ $t("unsubPage.stillReceiveUpdatesAboutDelivery") }}
                                    </p>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-12">
                                    <label for="newsletter-mailing-settings__textarea">
                                        {{ $t("unsubPage.feedBackAndTips") }}
                                    </label>
                                    <textarea
                                        id="newsletter-mailing-settings__textarea" rows="4" cols="50"
                                        v-model="optOutFeedbackField"
                                        class="newsletter-mailing-settings__textarea"
                                    ></textarea>
                                </div>
                            </div>
                            <div class="newsletter-mailing-settings__footer">
                                <a :href="cancelUrl" title="cancel Edit" class="button button--clear m-0">
                                    {{ $t("unsubPage.cancel")}}
                                </a>
                                <div id="submitUnsubscribeFormPlaceholder"></div>
                                <button
                                    @click="submitUnsubscribeFormRecaptcha"
                                    :disabled="unsubscribeFormDisabled"
                                    class="button-brekz button-brekz--rounded button-brekz--xl m-0 button-brekz--green"
                                >
                                    <span v-if="!optOutIsSubmitting && optOutIsSuccessful">
                                        <i class="fa fa-check h4 mb-0"></i>
                                    </span>
                                    <span v-else>{{ $t("unsubPage.save")}}</span>
                                </button>
                            </div>
                        </div>
                        <div v-if="errorBag.length > 0" class="col-12 mt-3 text--sm">
                            <i class="fas fa-times-circle text-danger mr-2"></i>
                            <span class="text-danger font-weight-bold">
                                {{ $t("myAccount.errorMessage") }}
                            </span>
                            <div v-for="error in errorBag">
                                <div class="text-danger ml-4" v-text="`- ${error.errorMessage}`"></div>
                            </div>
                        </div>
                    </div>
                </form>

                <div class="newsletter-mailing-settings__content-wrapper">
                    <div class="newsletter-mailing-settings__header">
                        <h2 class="newsletter-mailing-settings__title"> {{ $t("unsubPage.benefitDogCat")}}</h2>
                        <button @click="isContentSectionOpen = !isContentSectionOpen" class="newsletter-mailing-settings__header-toggle">
                            <i class="fa fa-chevron-up" aria-hidden="true" v-if="isContentSectionOpen"></i>
                            <i class="fa fa-chevron-down" aria-hidden="true" v-else></i>
                        </button>
                    </div>
                    <form method="POST" class="newsletter-mailing-settings__content" v-show="isContentSectionOpen">
                        <div>
                            <div class="newsletter-mailing-settings__content--desktop">
                                <div v-if="isCustomer" class="py-4">
                                    <label class="newsletter-mailing-settings__input-label">
                                        {{ $t("unsubPage.emailKnown") }}
                                        <span v-text="email"></span>
                                    </label>
                                </div>
                                <div v-else class="py-4 ml-4 col-8 form-group form-group__padding">
                                    <label for="email" class="w-100">
                                        <span>{{ $t("unsubPage.emailadres")}}</span>
                                        <input type="email" :value="email" id="email" name="email" class="form-control"  :class="{'input--error': checkInputUnsubscribe('email') }" disabled >
                                    </label>
                                </div>

                                <div class="newsletter-mailing-settings__input-wrapper newsletter-mailing-settings__input-wrapper--select">
                                    <label
                                        class="newsletter-mailing-settings__input-label newsletter-mailing-settings__input-label--select"
                                    >
                                        <div class="newsletter-mailing-settings__checkbox-input">
                                            <input @change="changeVoordeelmailsegment" type="checkbox" name="selectedVoordeelmailsegment" v-model="selectedVoordeelmailsegment">
                                        </div>
                                        <span class="newsletter-mailing-settings__label-text">
                                            {{ $t("unsubPage.iWantBenefitFor")}}
                                        </span>
                                    </label>
                                    <select
                                        name="voordeelsegmentValue" id="voordeelsegmentValue"
                                        class="newsletter-mailing-settings__select"
                                        @change="changeVoordeelmailsegment"
                                        v-model="voordeelSegmentValue"
                                    >
                                        <option :value="null">{{ $t("unsubPage.selectVariant")}}</option>
                                        <option value="1" :disabled="voordeelSegmentValueUnsub === '1'">{{ $t("unsubPage.dogs")}}</option>
                                        <option value="2" :disabled="voordeelSegmentValueUnsub === '2'">{{ $t("unsubPage.cats")}}</option>
                                        <option value="3" :disabled="voordeelSegmentValueUnsub === '3'">{{ $t("unsubPage.dogsAncCats")}}</option>
                                    </select>
                                </div>
                                <div class="newsletter-mailing-settings__input-wrapper newsletter-mailing-settings__input-wrapper--select">

                                    <label
                                        class="newsletter-mailing-settings__input-label newsletter-mailing-settings__input-label--select"
                                    >
                                        <div class="newsletter-mailing-settings__checkbox-input">
                                            <input
                                                type="checkbox"
                                                name="selectedVoordeelmailsegmentUnsub"
                                                v-model="selectedVoordeelmailsegmentUnsub"
                                                :disabled="voordeelSegmentValue === '3'">
                                        </div>
                                        <span class="newsletter-mailing-settings__label-text">{{ $t("unsubPage.iWant2")}} <span
                                            class="newsletter-mailing-settings__input-label--green"
                                        >{{$t("unsubPage.no")}}</span>
                                           {{$t("unsubPage.receiveMoreBenefitFor")}}
                                        </span>
                                    </label>
                                    <div>
                                        <select
                                            :disabled="voordeelSegmentValue === '3'"
                                            name="voordeelsegmentValueUnsub" id="voordeelsegmentValueUnsub"
                                            class="newsletter-mailing-settings__select"
                                            @change="changeUnsubDogOrCat"
                                            v-model="voordeelSegmentValueUnsub"
                                        >
                                            <option :value="null">{{ $t("unsubPage.selectVariant")}}</option>
                                            <option value="1" :disabled="voordeelSegmentValue === '1'">{{ $t("unsubPage.dogs")}}</option>
                                            <option value="2" :disabled="voordeelSegmentValue === '2'">{{ $t("unsubPage.cats")}}</option>
                                        </select>
                                        <span>{{ $t("unsubPage.received")}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-12 offset-md-1 col-md-11">
                                    <hr class="newsletter-mailing-settings__mobile-divider"/>
                                    <div class="newsletter-mailing-settings__input-wrapper">
                                        <input
                                            type="radio"
                                            v-model="selectedSubscribeOption"
                                            :value="0"
                                            name="selectedSubscribeOption"
                                            id="selectedSubscribeOption0"
                                            class="newsletter-mailing-settings__checkbox-input"
                                        >
                                        <label for="selectedSubscribeOption0" class="newsletter-mailing-settings__input-label">
                                            {{ $t("unsubPage.giveMe")}}
                                            <span class="newsletter-mailing-settings__input-label--green">
                                                	{{ $t("unsubPage.allBenefit")}}
                                            </span>
                                            <span class="newsletter-mailing-settings__input-label--italic">
                                                {{ $t("unsubPage.average2MailsAWeek")}}
                                            </span>
                                        </label>
                                    </div>
                                    <div class="newsletter-mailing-settings__input-wrapper">
                                        <input
                                            type="radio"
                                            v-model="selectedSubscribeOption"
                                            :value="1"
                                            class="newsletter-mailing-settings__checkbox-input"
                                            name="selectedSubscribeOption"
                                            id="selectedSubscribeOption1"
                                        >
                                        <label for="selectedSubscribeOption1" class="newsletter-mailing-settings__input-label">
                                            <span class="newsletter-mailing-settings__input-label--green">
                                                 {{ $t("unsubPage.oneTime2Weeks")}}
                                            </span>
                                        </label>
                                    </div>
                                    <div class="newsletter-mailing-settings__input-wrapper">
                                        <input
                                            type="radio"
                                            v-model="selectedSubscribeOption"
                                            :value="2"
                                            class="newsletter-mailing-settings__checkbox-input"
                                            name="selectedSubscribeOption"
                                            id="selectedSubscribeOption2"
                                        >
                                        <label for="selectedSubscribeOption2" class="newsletter-mailing-settings__input-label">
                                            <span class="newsletter-mailing-settings__input-label--green">
                                                 {{ $t("unsubPage.onetimeAMonth")}}
                                            </span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="newsletter-mailing-settings__footer">
                                <a :href="cancelUrl" title="cancel Edit" class="button button--clear m-0">
                                    {{ $t("unsubPage.cancel")}}
                                </a>
                                <div id="submitSubscribeFormPlaceholder"></div>
                                <button
                                    @click="submitSubscribeFormRecaptcha"
                                    :disabled="subscribeFormDisabled"
                                    class="button-brekz button-brekz--rounded button-brekz--xl m-0 button-brekz--green"
                                >
                                    <span v-if="!subscribeSubmitting && subscribeSubmittingIsSuccessful">
                                        <i class="fa fa-check h4 mb-0"></i>
                                    </span>
                                    <span v-else>
                                        {{ $t("unsubPage.save")}}
                                    </span>
                                </button>
                            </div>
                        </div>
                        <div v-if="errorBagSubscribe.length > 0" class="col-12 mt-3 text--sm">
                            <i class="fas fa-times-circle text-danger mr-2"></i><span class="text-danger font-weight-bold">{{ $t("myAccount.errorMessage") }}</span>
                            <div v-for="error in errorBagSubscribe">
                                <div class="text-danger ml-4" v-text="`- ${error.errorMessage}`"></div>
                            </div>
                        </div>
                    </form>
                </div>

            </div>
            <div class="col-12 col-md-2 col-lg-3">
            </div>

            <modal-vue :title="$t('unsubPage.YouAreSuccessfullyUnsubscribedFor')"
                       :show="showConfirmationModal"
                       :cancel-if-clicked-outside-modal="true"
                       @close="closeModal"
                       :buttons='[
                       {
                           text: $i18n.t("myAccount.close"),
                           class: "button button--extra-large button-brekz button-brekz--green button-brekz--rounded my-0 mx-auto",
                           emit_name: "close"
                       }
                   ]'>
                <div class="newsletter-mailing-settings__modal-content-wrapper">
                    <div v-show="this.conformationModalType === 'unsubScribe'">
                        <p v-if="selectedUnsubscribeOption === 0" class="newsletter-mailing-settings__input-label">
                            {{ $t("unsubPage.iWant")}}
                            <span class="newsletter-mailing-settings__input-label--green">
                                    {{ $t("unsubPage.keepProfiting")}}
                                </span>
                            {{ $t("unsubPage.ofTheBenefitMail") }}
                        </p>
                        <p v-else-if="selectedUnsubscribeOption === 1" class="newsletter-mailing-settings__input-label">
                            {{ $t("unsubPage.sendMe") }}
                            <span class="newsletter-mailing-settings__input-label--green"> {{ $t("unsubPage.onesEvery2Weeks") }}</span>
                            {{ $t("unsubPage.exclusiveOffersAndTheBestDiscounts") }}
                        </p>
                        <p v-else-if="selectedUnsubscribeOption === 2" class="newsletter-mailing-settings__input-label">
                            <span class="newsletter-mailing-settings__input-label--green">{{ $t("unsubPage.onetimeAMonth")}}</span>
                            {{ $t("unsubPage.wellEnoughButDontMiss") }}
                        </p>
                        <ul  v-else-if="selectedUnsubscribeOption === 3" class="newsletter-mailing-settings__modal-list">
                            <li v-if="selectedOptOutOptions.discountMail" class="newsletter-mailing-settings__modal-list-item">
                                <span>{{ $t("unsubPage.benefitMail") }}</span>
                            </li>
                            <li v-if="selectedOptOutOptions.birthdayMail" class="newsletter-mailing-settings__modal-list-item">
                                <span>{{ $t("unsubPage.birthdayMail")}}</span>
                            </li>
                            <li v-if="selectedOptOutOptions.tipsAndAdviseMail" class="newsletter-mailing-settings__modal-list-item">
                                <span>{{ $t("unsubPage.tipsAndAdvice") }}</span>
                            </li>
                            <li v-if="selectedOptOutOptions.personalDiscountMail" class="newsletter-mailing-settings__modal-list-item">
                                <span>{{ $t("unsubPage.personalDiscount") }}</span>
                            </li>
                            <li v-if="selectedOptOutOptions.reviewMail" class="newsletter-mailing-settings__modal-list-item">
                                <span>{{ $t("unsubPage.productReviewAndReviews") }}</span>
                            </li>
                        </ul>
                    </div>
                    <div v-show="this.conformationModalType === 'subscribe'">
                        <p v-if="selectedVoordeelmailsegment && voordeelSegmentValue" class="newsletter-mailing-settings__input-label">
                            {{ $t("unsubPage.iWantBenefitFor")}}
                            <span v-if="voordeelSegmentValue === '1'" class="newsletter-mailing-settings__input-label--green">{{ $t("unsubPage.dogs")}}</span>
                            <span v-else-if="voordeelSegmentValue === '2'" class="newsletter-mailing-settings__input-label--green">{{ $t("unsubPage.cats")}}</span>
                            <span v-else-if="voordeelSegmentValue === '3'" class="newsletter-mailing-settings__input-label--green">{{ $t("unsubPage.dogsAncCats")}}</span>
                        </p>
                        <p v-if="selectedVoordeelmailsegmentUnsub && voordeelSegmentValueUnsub" class="newsletter-mailing-settings__input-label">
                            <span>{{ $t("unsubPage.iWant2")}} <span
                                class="newsletter-mailing-settings__input-label--green"
                            >{{$t("unsubPage.no")}}</span>
                                           {{$t("unsubPage.receiveMoreBenefitFor")}}
                                        </span>
                            <span v-if="voordeelSegmentValueUnsub === '1'" class="newsletter-mailing-settings__input-label--green">{{ $t("unsubPage.dogs")}}</span>
                            <span v-else-if="voordeelSegmentValueUnsub === '2'" class="newsletter-mailing-settings__input-label--green">{{ $t("unsubPage.cats")}}</span>
                            <span v-else-if="voordeelSegmentValueUnsub === '3'" class="newsletter-mailing-settings__input-label--green">{{ $t("unsubPage.dogsAncCats")}}</span>
                        </p>
                        <p v-if="selectedSubscribeOption === 0" class="newsletter-mailing-settings__input-label">
                            {{ $t("unsubPage.giveMe")}}
                            <span class="newsletter-mailing-settings__input-label--green">
                                    {{ $t("unsubPage.allBenefit")}}
                            </span>
                            <span class="newsletter-mailing-settings__input-label--italic">
                                {{ $t("unsubPage.average2MailsAWeek")}}
                            </span>
                        </p>
                        <p v-if="selectedSubscribeOption === 1" class="newsletter-mailing-settings__input-label--green">
                            {{ $t("unsubPage.oneTime2Weeks")}}
                        </p>
                        <p v-if="selectedSubscribeOption === 2" class="newsletter-mailing-settings__input-label--green">
                            {{ $t("unsubPage.onetimeAMonth")}}
                        </p>
                    </div>
                    <span>{{ $t("unsubPage.emailadres")}} {{this.email}}</span>
                </div>
            </modal-vue>
        </div>
    </div>
</template>
<script>
import axios from "axios";

export default {
    name: "CopernicaUnsubscribe",
    props: {
        idShop: {
            type: Number,
            required: true
        },
        languageIso: {
            type: String,
            required: true
        },
        customerEmail: {
            type: String,
            required: false
        },
        formPostUrl: {
            type: String,
            required: true
        },
        fallbackCancelUrl: {
            type: String,
            required: true
        },
        recaptchaKey: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            isContentSectionOpen: false,
            showConfirmationModal: false,
            conformationModalType: null,
            email: '',
            isCustomer: false,
            optOutIsSubmitting: false,
            subscribeSubmitting: false,
            subscribeSubmittingIsSuccessful: false,
            optOutIsSuccessful: false,
            optOutFeedbackField: '',
            selectedUnsubscribeOption: null,
            selectedSubscribeOption: 0,
            selectedOptOutOptions: {
                discountMail: false,
                birthdayMail: false,
                tipsAndAdviseMail: false,
                personalDiscountMail: false,
                reviewMail: false,
            },
            voordeelmailsegmentkat: false,
            voordeelmailsegmenthond: false,
            voordeelSegmentValue: null,
            voordeelSegmentValueUnsub: null,
            selectedVoordeelmailsegment: false,
            selectedVoordeelmailsegmentUnsub: false,
            errorBag: [],
            errorBagSubscribe: [],
            optOutIsSubmittingFailed: false,
            subscribeSubmittingFailed: false,
            submitUnsubscribeFormRecaptchaToken: '',
            submitSubscribeFormRecaptchaToken: '',
        };
    },
    methods: {
        submitUnsubscribeFormRecaptcha(e) {
            e.preventDefault();

            grecaptcha.ready(() => {
                grecaptcha.execute(this.recaptchaKey, { action: 'unsubscribe' }).then((token) => {
                    this.submitUnsubscribeFormRecaptchaToken = token;
                    this.submitUnsubscribeForm();
                });
            });
        },
        checkUnsubscribeForm() {
            let success = true;
            this.errorBag = [];

            if(!this.validateEmail(this.email)) {
                this.errorBag.push({
                    "fieldName": "email",
                    "errorMessage" : this.$t('unsubPage.checkYourEmail')
                });
                success = false;
            }

            if(this.selectedUnsubscribeOption === null) {
                this.errorBag.push({
                    "fieldName": "option",
                    "errorMessage" : this.$t('unsubPage.noOptionSelected')
                });
                success = false;
            }

            return success;
        },
        checkInput(inputName) {
            for (let i = 0; i < this.errorBag.length; i++) {
                if (this.errorBag[i].fieldName === inputName) {
                    return true;
                }
            }

            return false;
        },
        checkInputUnsubscribe(inputName) {
            for (let i = 0; i < this.errorBagSubscribe.length; i++) {
                if (this.errorBagSubscribe[i].fieldName === inputName) {
                    return true;
                }
            }

            return false;
        },
        submitUnsubscribeForm() {
            if (this.unsubscribeFormDisabled) {
                return;
            }
            if (this.checkUnsubscribeForm()) {

                this.optOutIsSubmitting = true;
                let bodyFormData = new FormData();
                bodyFormData.append('g-recaptcha-response', this.submitUnsubscribeFormRecaptchaToken);
                bodyFormData.append('Email', this.email);
                bodyFormData.append('Optout_Nieuwsbrief', this.selectedUnsubscribeOption === 3 && this.selectedOptOutOptions.discountMail ? 1 : 0);
                bodyFormData.append('Optout_Verjaardagsmail', this.selectedUnsubscribeOption === 3 && this.selectedOptOutOptions.birthdayMail ? 1 : 0);
                bodyFormData.append('Optout_Tipsenadvies', this.selectedUnsubscribeOption === 3 && this.selectedOptOutOptions.tipsAndAdviseMail ? 1 : 0);
                bodyFormData.append('Optout_Persoonlijkekorting', this.selectedUnsubscribeOption === 3 && this.selectedOptOutOptions.personalDiscountMail ? 1 : 0);
                bodyFormData.append('Optout_Review', this.selectedUnsubscribeOption === 3 && this.selectedOptOutOptions.reviewMail ? 1 : 0);
                bodyFormData.append('Feedback', this.optOutFeedbackField);
                bodyFormData.append('Frequency', this.selectedUnsubscribeOption); // 0 - ingeschreven blijven, 1 - 1x in de 2 weken, 2 - 1x in de 4 weken, 3 - volledig uitschrijven

                axios({
                    method: "post",
                    url: this.formPostUrl,
                    data: bodyFormData,
                    headers: { "Content-Type": "multipart/form-data" },
                })
                    .then((response) => {
                        document.body.classList.add("modal-vue--open");
                        this.optOutIsSuccessful = true;
                        this.showConfirmationModal = true;
                        this.optOutIsSubmitting = false;
                        this.conformationModalType = "unsubScribe";
                    })
                    .catch((response) => {
                        this.optOutIsSubmitting = false;
                        this.optOutIsSuccessful = false;
                        this.recaptchaFailedMessage('errorBag', response);
                    });
            }

            this.optOutIsSubmittingFailed = true;

        },
        submitSubscribeFormRecaptcha(e) {
            e.preventDefault();

            grecaptcha.ready(() => {
                grecaptcha.execute(this.recaptchaKey, { action: 'subscribe' }).then((token) => {
                    this.submitSubscribeFormRecaptchaToken = token;
                    this.submitSubscribeForm();
                });
            });
        },
        checkSubscribeForm() {
            let success = true;
            this.errorBagSubscribe = [];

            if(!this.email) {
                this.errorBagSubscribe.push({
                    "fieldName": "email",
                    "errorMessage" : this.$t('unsubPage.checkYourEmail')
                });
                success = false;
            }
            if (!this.voordeelmailsegmentkat && !this.voordeelmailsegmenthond) {
                this.errorBagSubscribe.push({
                    "fieldName": "variant",
                    "errorMessage": this.$t('unsubPage.noOptionSelected')
                });
                success = false;
            } else if (!this.selectedVoordeelmailsegment && !this.selectedVoordeelmailsegmentUnsub) {
                this.errorBagSubscribe.push({
                    "fieldName": "variant",
                    "errorMessage": this.$t('unsubPage.noOptionSelected')
                });
                success = false;
            }
            return success;
        },
        submitSubscribeForm() {
            if (this.subscribeFormDisabled) {
                return;
            }
            if (this.checkSubscribeForm()) {

                this.subscribeSubmitting = true;

                let bodyFormData = new FormData();
                bodyFormData.append('g-recaptcha-response', this.submitSubscribeFormRecaptchaToken);
                bodyFormData.append('Email', this.email);
                bodyFormData.append('Frequency', this.selectedSubscribeOption);// 0 - ingeschreven blijven, 1 - 1x in de 2 weken, 2 - 1x in de 4 weken, 3 - volledig uitschrijven
                bodyFormData.append('Voordeelmailsegmenthond', this.voordeelmailsegmenthond);
                bodyFormData.append('Voordeelmailsegmentkat', this.voordeelmailsegmentkat);

                axios({
                    method: "post",
                    url: this.formPostUrl,
                    data: bodyFormData,
                    headers: { "Content-Type": "multipart/form-data" },
                })
                    .then((response) => {
                        this.subscribeSubmittingIsSuccessful = true;
                        this.subscribeSubmitting             = false;
                    })
                    .catch((response) => {
                        this.subscribeSubmittingIsSuccessful = false;
                        this.subscribeSubmitting             = false;
                        this.recaptchaFailedMessage('errorBagSubscribe', response);

                    });

            }
            this.subscribeSubmittingFailed = true;
        },
        changeVoordeelmailsegment(){

            if (this.voordeelSegmentValue === '3') {
                switch(this.selectedVoordeelmailsegmentUnsub) {
                    case '1':
                        this.voordeelmailsegmenthond = 1;
                        break;
                    case '2':
                        this.voordeelmailsegmentkat  = 1;
                        break;
                    default:
                        this.voordeelmailsegmenthond = 3;
                        this.voordeelmailsegmentkat  = 3;
                        this.selectedVoordeelmailsegmentUnsub = null;
                        break;
                }
                if (this.subscribeSubmittingFailed) {
                    this.checkSubscribeForm();
                }
                return;
            }

            if(this.voordeelSegmentValue === "1") {
                this.voordeelmailsegmenthond = 3
                if (this.voordeelmailsegmentkat === 3) {
                    this.voordeelmailsegmentkat = false;
                }
            }

            if(this.voordeelSegmentValue === "2") {
                this.voordeelmailsegmentkat = 3
                if (this.voordeelmailsegmenthond === 3) {
                    this.voordeelmailsegmenthond = false;
                }
            }

            if (!this.voordeelSegmentValue) {
                if (this.voordeelmailsegmentkat === 3) {
                    this.voordeelmailsegmentkat = false;
                }
                if (this.voordeelmailsegmenthond === 3) {
                    this.voordeelmailsegmenthond = false;
                }
            }
            if (this.subscribeSubmittingFailed) {
                this.checkSubscribeForm();
            }

        },
        changeUnsubDogOrCat() {
            if (this.voordeelSegmentValueUnsub === '1') {
                this.voordeelmailsegmenthond = 1;

                if (this.voordeelmailsegmentkat  === 1) {
                    this.voordeelmailsegmentkat = false;
                }

                if (this.voordeelSegmentValue === '3'){
                    this.voordeelmailsegmentkat  = 3;
                }
            }
            if (this.voordeelSegmentValueUnsub === '2') {
                this.voordeelmailsegmentkat  = 1;

                if (this.voordeelmailsegmenthond  === 1) {
                    this.voordeelmailsegmenthond = false;
                }

                if (this.voordeelSegmentValue === '3'){
                    this.voordeelmailsegmenthond  = 3;
                }
            }

            if(!this.voordeelSegmentValueUnsub) {
                if(this.voordeelmailsegmentkat === 1) {
                    this.voordeelmailsegmentkat = false;
                }
                if(this.voordeelmailsegmenthond === 1) {
                    this.voordeelmailsegmenthond = false;
                }

            }
        },
        handleRecaptchaSuccessUnsub(response) {
            this.submitUnsubscribeFormRecaptchaToken = response;
        },
        handleRecaptchaFailedUnsub() {
            this.submitUnsubscribeFormRecaptchaToken = '';
        },
        handleRecaptchaSuccessSub(response) {
            this.submitSubscribeFormRecaptchaToken = response;
        },
        handleRecaptchaFailedSub() {
            this.submitSubscribeFormRecaptchaToken = '';
        },
        closeModal() {
            document.body.classList.remove("modal-vue--open");
            if (this.showConfirmationModal) {
                this.showConfirmationModal = false;
                this.conformationModalType = null;
            }
        },
        validateEmail(email) {
            var re = /^[a-z\u00DF\u00E0-\u00FF0-9+\/=?^`{}|~_-]+[.a-z0-9+\/=?^`{}|~_-]*@[a-z0-9]+[._a-z\p{L}0-9-]*\.[a-z0-9]+$/i;
            return re.test(email);
        },

        recaptchaFailedMessage(form, response) {
            let errorMessage = response.response.data;

            if (!errorMessage || response.response.status === 500) {
                errorMessage = 'Server error';
            }

            if (form === 'errorBag') {
                this.errorBag.push({
                    "fieldName": "recaptchaFailed",
                    "errorMessage": errorMessage
                });
            }

            if(form === 'errorBagSubscribe') {
                this.errorBagSubscribe.push({
                    "fieldName": "recaptchaFailed",
                    "errorMessage": errorMessage
                });
            }
        }
    },
    computed: {
        sadnessLevelOfTheDog() {
            if (!this.selectedUnsubscribeOption) {
                return `/themes/brekz-2017/img/unsubscribe-mail-${this.languageIso}-0.png`;
            }
            return `/themes/brekz-2017/img/unsubscribe-mail-${this.languageIso}-${this.selectedUnsubscribeOption}.png`;
        },
        cancelUrl() {
            return document.referrer ? document.referrer : this.fallbackCancelUrl;
        },
        unsubscribeFormDisabled() {
            if (this.optOutIsSubmitting) {
                return true;
            }

            if (this.email) {
                return false;
            }

            // if (this.submitUnsubscribeFormRecaptchaToken === '') {
            //     return true;
            // }

            return false;
        },
        subscribeFormDisabled() {
            if (this.subscribeSubmitting) {
                return true;
            }

            if (this.email) {
                return false;
            }

            // if (this.submitSubscribeFormRecaptchaToken === '') {
            //     return true;
            // }

            return false;
        }
    },
    watch: {
        selectedUnsubscribeOption(newValue, oldValue) {
            if (newValue === 3) {
                this.selectedOptOutOptions.discountMail = true;
                this.selectedOptOutOptions.birthdayMail = true;
                this.selectedOptOutOptions.tipsAndAdviseMail = true;
                this.selectedOptOutOptions.personalDiscountMail = true;
                this.selectedOptOutOptions.reviewMail = true;
            } else {
                this.selectedOptOutOptions.discountMail = false;
                this.selectedOptOutOptions.birthdayMail = false;
                this.selectedOptOutOptions.tipsAndAdviseMail = false;
                this.selectedOptOutOptions.personalDiscountMail = false;
                this.selectedOptOutOptions.reviewMail = false;
            }
            if (this.optOutIsSubmittingFailed) {
                this.checkUnsubscribeForm()
            }
        },
        email: function() {
            if (this.optOutIsSubmittingFailed) {
                this.checkUnsubscribeForm()
            }

            if(this.subscribeSubmittingFailed) {
                this.checkSubscribeForm()
            }
            // this.unsubscribeFormDisabled();
            // this.subscribeFormDisabled();
        },
        voordeelmailsegmentkat: function() {
            if(this.subscribeSubmittingFailed) {
                this.checkSubscribeForm()
            }
        },
        voordeelmailsegmenthond: function() {
            if(this.subscribeSubmittingFailed) {
                this.checkSubscribeForm()
            }
        },
        selectedSubscribeOption: function() {
            if(this.subscribeSubmittingFailed) {
                this.checkSubscribeForm()
            }
        },
        selectedVoordeelmailsegment: function() {
            if(!this.selectedVoordeelmailsegment) {
                this.voordeelSegmentValue = null;
                this.changeVoordeelmailsegment();
            }
        },
        selectedVoordeelmailsegmentUnsub: function() {
            if(!this.selectedVoordeelmailsegmentUnsub) {
                this.voordeelSegmentValueUnsub = null;
                this.changeUnsubDogOrCat();
            }
            if (this.subscribeSubmittingFailed) {
                this.checkSubscribeForm();
            }
        }
    },
    mounted() {
        this.email = this.customerEmail;
        if (this.email) {
            this.isCustomer = true;
        }

        // grecaptcha.render('submitUnsubscribeFormPlaceholder', {
        //     'sitekey' : this.recaptchaKey,
        //     'callback' : this.handleRecaptchaSuccessUnsub,
        //     'expired-callback': this.handleRecaptchaFailedUnsub,
        //     'error-callback': this.handleRecaptchaFailedUnsub
        // });

        // grecaptcha.render('submitSubscribeFormPlaceholder', {
        //     'sitekey' : this.recaptchaKey,
        //     'callback' : this.handleRecaptchaSuccessSub,
        //     'expired-callback': this.handleRecaptchaFailedSub,
        //     'error-callback': this.handleRecaptchaFailedSub
        // });
    }
};
</script>
